import React from 'react';
import FooterForm from './FooterForm';

const Footer = () => {
    return (
        <div className='footer-bg'>

            <FooterForm></FooterForm>
            
        </div>
    );
};

export default Footer;